<template>
  <div class="order">
    <Header title="订单详情" style="background-color: #fff;"></Header>
    <div class="order-detail">
      <div class="order-status">
        <img src="@/assets/imgs/order/编组 40备份@2x.png" alt="">
        <span style="font-weight: bold;">当前状态：</span>
        <span>{{ statusName }}</span>
      </div>
      <OrderPrice :order="orderData"></OrderPrice>
      <OrderInfoCardDetail :order="orderData"></OrderInfoCardDetail>
      <OrderCommodityCard :orderDetail="productData" :advanceSalePlanInfo="advanceSalePlanInfo"></OrderCommodityCard>
      <OrderPayCard :order="orderData"></OrderPayCard>
      <OrderDeliveryTypeCard :orderDetail="productData" :order="orderData"></OrderDeliveryTypeCard>
      <OrderInvoiceCard :invoiceInfo="invoiceInfo"></OrderInvoiceCard>
      <div class="card">
        <div class="info">
          <div class="title">
            <h1 style="font-weight: bold;">备注信息</h1>
            <img src="@/assets/imgs/order/3.1 返回1@2x(1).png" alt="" @click="toggleShow">
          </div>
          <van-field v-if="showDetails" type="textarea" v-model="orderData.remark" rows="3" maxlength="50" placeholder="请输入" border></van-field>
        </div>
      </div>
      <div class="agreement" v-if="orderData.status == '01' || canSubmit">
        <van-checkbox-group v-model="agreementChecked">
          <div v-for="(item, index) in orderData.agreementSignList" :key="index">
            <van-checkbox class="checkbox-div" shape="square" :disabled="!canSubmit" checked-color="#333333" name="index">
              签订{{ item.agreementName }}查看
              <span class="link" @click.stop="viewAgreement(item.agreementType, item.templateId)">{{ item.agreementName }}</span>
            </van-checkbox>

          </div>
        </van-checkbox-group>
      </div>
    </div>

    <div class="bottom-btn" v-if="orderData.tradeType=='JH' && orderData.status == '9'"
         style="justify-content: space-around">
      <van-button class="submit-btn" @click="viewComment(orderData)" v-show="orderData.evaluation">查看评价</van-button>
      <van-button class="submit-btn" @click="goComment(orderData)" v-show="!orderData.evaluation">去评价</van-button>
    </div>

    <div class="bottom-btn" v-if="orderData.tradeType=='JH' && canSubmit">
      <div class="confirm-order__price">¥ <span>{{productData.amount}}</span></div>
      <van-button class="submit-btn" @click="submitConfirm">确认提交</van-button>
    </div>
    <viewAgreement ref="Agreement"></viewAgreement>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import OrderInfoCardDetail from "./components/OrderInfoCardDetail";
import OrderCommodityCard from "./components/OrderCommodityCard";
import OrderPayCard from "./components/OrderPayCard";
import OrderDeliveryTypeCard from "./components/OrderDeliveryTypeCard";
import OrderPrice from "./components/OrderPrice";
// import OrderDeliveryCard from "./components/OrderDeliveryCard";
import OrderInvoiceCard from "./components/OrderInvoiceCard";
import orderApi from "@/request/orderApi";
// import listApi from "@/request/listApi";
import viewAgreement from "@/components/viewAgreement";
export default {
  name: "OrderDetail",
  components: {
    Header,
    OrderInfoCardDetail,
    OrderCommodityCard,
    OrderPayCard,
    OrderDeliveryTypeCard,
    // OrderDeliveryCard,
    OrderInvoiceCard,
    viewAgreement,
    OrderPrice
  },
  data() {
    return {
      deliveryMode2:"",
      constants: this.$common.interfacePath,
      canSubmit: false,
      agreementChecked: [],
      currentStep: 0,
      advanceSalePlanInfo: {}, //月计划量
      form: {
        remark: "",
        ifDepositToPayment: "1",
        deliveryMode: "1",
        deliveryAddress: "",
      },
      contractInfo: {
        contractNo: "",
        price: "",
        totalWeight: "",
        executedWeight: "",
        validDateBegin: "",
        validDateEnd: "",
      },
      copartnerInfo:{},//之前取值有问题最新开票信息
      invoiceInfo: {}, //开票信息
      concessionDetailList: [], //优惠信息

      formInit: {
        orderType: [],
        priceType: [
          {
            itemCode: "02",
            itemName: "定价",
          },
          {
            itemCode: "01",
            itemName: "挂牌",
          },
        ],
        sendType: [
          {
            itemCode: "Z",
            itemName: "直发",
          },
          {
            itemCode: "K",
            itemName: "库发",
          },
          {
            itemCode: "D",
            itemName: "断卖",
          },
        ],
        deliveryType: [
          {
            itemCode: "1",
            itemName: "自提",
          },
          {
            itemCode: "2",
            itemName: "配送",
          },
        ],
        status: [
          //订单状态
          {
            itemName: "已撤销",
            itemCode: "-1",
          },
          {
            itemName: "待提交",
            itemCode: "0",
          },
          {
            itemName: "待确认",
            itemCode: "0_1", //其他交易模式
          },
          {
            itemName: "待确认",
            itemCode: "0_2", //待客户下单
          },
          {
            itemName: "待确认",
            itemCode: "0_3", //业务员初审之后再确认
          },
          {
            itemName: "待审核",
            itemCode: "1",
          },
          {
            itemName: "审核中",
            itemCode: "2",
          },
          {
            itemName: "待发货",
            itemCode: "3",
          },
          {
            itemName: "发货中",
            itemCode: "4",
          },
          {
            itemName: "已完成",
            itemCode: "9",
          },
        ],
      },
      single: false,
      orderData: {}, //详情数据
      productData: {}, //商品详情
      deliveryAddressConfigOption: [], //配送地址
      showDetails: true, // 控制价格详情是否显示
    };
  },
  mounted() {
    this.getOrderdetail();
  },
  computed: {
     statusName() {
        let statusName;
        switch (this.orderData.status) {
          case "1":
            statusName = "待审核，请等待审核";
            break;
          case "2":
            statusName = "审核中,请等待审核";
            break;
          case "3":
            statusName = "已审批通过，待发货";
            break;
          case "4":
            statusName = "发货中";
            break;
          case "9":
            statusName = "已完成，待评价";
            break;
          case "0_1":
            statusName = "待确认，请确认";
            break;
          case "0_2":
            statusName = "待确认，请确认";
            break;
          case "0_3":
            statusName = "待确认，请确认";
            break;
          case "0_4":
            statusName = "待审核，请等待审核";
            break;
          case "-1":
            statusName = "已取消";
            break;
          case "2_2":
            statusName = "审核中，请等待审核";
            break;
          case "1_1":
            statusName = "待审核，请等待审核！";
            break;
        }
        return statusName;
    },      
  },
  methods: {
    cancelOrder() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确定取消订单？",
        })
        .then(() => {
          let params = {
            orderId: this.orderData.id
          };
          orderApi.cancel(params).then((res) => {
            if (res.returnCode == "0") {
              this.$toast.success("撤销成功");
            } else {
              this.$toast({
                type: "fail",
                message: res.returnMessage,
                duration: 1500,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 获取到详情
    getOrderdetail() {
      let params = {
        id: this.$route.query.id,
      };
      orderApi.orderDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.orderData = res.result;
          // this.setCurrentStep(res.result.status);
          this.productData = res.result.orderDetailInfoList[0];
          this.productData.erpAccountBalance = res.result.erpAccountBalance
          console.log(this.productData);
          this.copartnerInfo=res.result.copartnerInfo
          this.invoiceInfo = res.result.invoiceInfo;
          this.advanceSalePlanInfo = res.result.advanceSalePlanInfo;
          this.concessionDetailList = res.result.concessionDetailList;
          this.deliveryAddressConfigOption = res.result.deliveryAddressConfigOption;
          this.deliveryMode2 = res.result.orderDetailInfoList[0] && res.result.orderDetailInfoList[0].deliveryMode;

          this.form.ifDepositToPayment =
            this.form.ifDepositToPayment == null
              ? "1"
              : this.form.ifDepositToPayment;

          this.canSubmit =
            res.result.status == "0_1" ||
            res.result.status == "0_2" ||
            res.result.status == "0_3";

          console.log("canSubmit", this.canSubmit)
          let self = this;
          res.result.agreementSignList.forEach(function (item, index) {
            if (item.signed == "1") {
              self.agreementChecked.push(index);
            }
          });
          this.orderData.agreementSignList = res.result.agreementSignList;
          console.log("p,mkklk", this.orderData.agreementSignList);
         
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //查看协议
    viewAgreement(agreementType, templateId) {
      this.$refs.Agreement.viewAgreement(agreementType, templateId);
    },
    // viewAgreement(agreementType, templateId) {
    //   console.log(agreementType, templateId);
    //   this.$router.push({
    //     path: "/viewAgreement",
    //     query: {
    //       agreementType,
    //       templateId,
   
    //     this.$toast({
    //       type: "fail",
    //       message: res.returnMessage,
    //       duration: 1500,
    //     });
    //   }
    // },
    submitConfirm() {
      let self = this;
      let agreementCheck = true;
      this.orderData.agreementSignList.forEach(function(item, index) {
        if (
          item.mustAgreeFlag == "1" &&
          self.agreementChecked.find(item2 => item2 == index) == null
        ) {
          //必须同意的协议
          agreementCheck = false;
          return self.$toast.fail("请阅读并同意" + item.agreementName);
        }
      });
     
      if (!agreementCheck) {
        return;
      }

      let agreementSignListParam = [];
      self.agreementChecked.forEach((item) =>
        agreementSignListParam.push(this.orderData.agreementSignList[item])
      );

      let params = {
        orderId: this.$route.query.id,
        operate: "1",
        ifDepositToPayment: this.form.ifDepositToPayment,
        remark: this.form.remark,
        agreementSignList: agreementSignListParam,
        deliveryMode: this.form.deliveryMode,
        deliveryAddress: this.form.deliveryAddress,
      };
      orderApi.recheckOrder(params).then(res=> {
        if (res.returnCode == "0") {
          this.$toast.success("确认订单成功");
          history.back();
         
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }

      });
        
    },
    // goComment(val) {
    //   // this.$refs.orderComment.show();
    //   this.appraise={
    //     evaluateInfo:"",//评价信息
    //     expertCode:"",//专家编号
    //     expertSrvId:"",//主键id
    //     createUserId:"",//申请人id
    //   }
    //   this.appraise.evaluateInfo=val.evaluateInfo
    //   this.appraise.expertCode=val.expertCode
    //   this.appraise.expertSrvId=val.expertSrvId
    //   this.appraise.createUserId=val.createUserId
    //   this.$router.push({
    //     path: "/comment",
    //     query: this.appraise
    //   });

    // },
    goComment() {
      this.$router.push("/comment");
    },
    viewComment(order) {
     this.$router.push("/comment?id=" + order.id);
    },
    toggleShow() {
      this.showDetails = !this.showDetails; // 切换显示状态
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.order {
  // display: flex;
  // flex-direction: column;
  height: 100%;
  background: #f0f1f5;

  .order-detail {
    position: relative;
    // padding: 0 20px;
    overflow: auto;
    background #F0F1F5

    .order-status {
      display: flex;
      align-items: center;
      padding: 0 24px;
      margin: 28px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #333333;

      span:nth-child(3) {
        color: #E0000C;
      }

      img {
        width: 48px;
        height: 48px;
        margin-right: 16px;
      }
    }

    .card {
      // margin-top: 24px;
      // background: #ffffff;
      // padding: 0 24px;
      // font-size: 26px;
      .title {
        margin: 32px 0;
        padding: 0 34px;
        display: flex;
        justify-content: space-between;

        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
        }

        img {
          width: 32px;
          height: 32px;
        }
      }

      .info {
        // padding: 16px 0;
      }
    }

    .agreement {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 34px 32px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #333333;

      .link {
        height: 37px;
        font-size: 26px;
        font-weight: 400;
        line-height: 37px;
        color: #E0000C;
        opacity: 1;
      }
    }

    >>> .van-cell {
      line-height: 49px;
      border: 1PX solid transparent;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #666666;
    }
  }
}

.bottom-btn {
  margin-top 10px
  background: #FFFFFF;
  height: 130px;
  text-align: center;
  line-height: 130px;
  display flex
  justify-content space-between
  align-items center
  padding 0 32px

  .submit-btn {
    width: 236px;
    height: 64px;
    background: #E0000C;
    opacity: 1;
    border-radius: 40px;
    font-size: 28px;
    color: #FFFFFF;
  }

  .confirm-order__price{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #FF5500;
    span{
      font-size 40px
    }
  }
}
</style>
